var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.3 56.3",
    enableBackground: "new 0 0 56.3 56.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.1,0C12.6,0,0,12.6,0,28.1s12.6,28.1,28.1,28.1s28.1-12.6,28.1-28.1S43.6,0,28.1,0z M32.2,28.5h-3  c0,4.8,0,10.7,0,10.7h-4.4c0,0,0-5.8,0-10.7h-2.1v-3.8h2.1v-2.4c0-1.7,0.8-4.5,4.5-4.5l3.3,0v3.7c0,0-2,0-2.4,0  c-0.4,0-0.9,0.2-0.9,1v2.2h3.4L32.2,28.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbHover);
export default __webpack_public_path__ + "static/media/fb-hover.70ee7f349d220671bfa4c7a062a12265.svg";
export { ForwardRef as ReactComponent };